// Entry global do redesign. Precisa ficar na raiz de assets/javascripts porque
// o build só reconhece entry points em javascripts/ e javascripts/pages/.
//
// Imports "./common" e "./components" ainda são legacy. Cada fase do redesign
// troca um deles pelo equivalente em "./redesign".

import CartDrawer from './redesign/common/cartDrawer';
import Footer from './common/footer';
import Header from './redesign/common/header';
import MenuMobile from './redesign/common/menuMobile';
import Search from './redesign/common/search';
import Popup from './components/popup';
import Webforms from './common/webforms';
import ProductPurchase from './components/productPurchase';
import { NewsletterComponent, PriceComponent } from './components/vndaComponents.js';
import { setProductsSwiper } from './components/utilities';
import AOS from 'aos';
import setHeroVideo from './redesign/home/heroVideo';

let threshold = 700;
if (window.innerWidth < 768) threshold = 400

window.lazyLoadOptions = {
  elements_selector: ".lazy",
  threshold
};

window.addEventListener("LazyLoad::Initialized", event => {
  window.lazyLoadInstance = event.detail.instance
}, { passive: true });

window.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  Header.init();
  Footer.init();
  Popup.init();
  ProductPurchase.init();
  PriceComponent.init();
  Webforms.init();
  NewsletterComponent.init();
  setProductsSwiper();
  MenuMobile.init();
  Search.init();
  setHeroVideo();

  window.addEventListener('load', () => {
    AOS.init({
      once: true,
    });
  });
});
